import { css } from '@compiled/react';

import { LoomOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { JoinableSites } from '@/components/signup/site-activation/components/common/joinable-sites';
import { ReturnToProduct } from '@/components/signup/site-activation/components/common/return-to-product';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';

import { Headings } from '../../components/headings';
import { FreeForTenUsersText } from '../../components/sub-heading';
import { WelcomeBackText } from '../../components/welcome-back-heading';

// Loom logged-in signup for users who already have sites. Mirrors the
// Jira/Confluence structure (boxed multi-site list with "Go to <product>"
// cards, "Switch account", and "or start a new site") by routing through the
// shared SiteActivation switcher with contact-expand cohort logic, while
// keeping the Loom backdrop (LoomOverlayTemplate) and Loom copy.
export const LoggedInLoomExistingSitesUser = () => (
	<LoomOverlayTemplate size="sm">
		<div css={containerCss}>
			<Headings main={<WelcomeBackText />} sub={<FreeForTenUsersText />} />
			<SiteActivation
				CurrentProductUser={<ReturnToProduct />}
				CurrentProductJoinableUser={<JoinableSites />}
				useContactExpandCohortLogic
			/>
		</div>
	</LoomOverlayTemplate>
);

const containerCss = css({
	display: 'grid',
	gap: '10px',
});
